import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import ModuleChip from '../components/ModuleChip.js';
import { useActivity } from './Conductor/useActivity.js';

function relativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  const now = Date.now();
  const diff = Math.max(0, now - then);
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

export default function Activity() {
  const { entries, loading, error } = useActivity();
  const [moduleFilter, setModuleFilter] = useState<string | null>(null);

  const modules = useMemo(() => {
    const set = new Set<string>();
    for (const e of entries) {
      if (e.module) set.add(e.module);
    }
    return [...set].sort();
  }, [entries]);

  const visible = moduleFilter ? entries.filter((e) => e.module === moduleFilter) : entries;

  return (
    <div>
      {modules.length > 0 && (
        <div className="badge-row" style={{ flexWrap: 'wrap', marginBottom: 16 }}>
          <button
            type="button"
            className="btn-outline-conductor"
            style={{ opacity: moduleFilter === null ? 1 : 0.6 }}
            onClick={() => setModuleFilter(null)}
          >
            All
          </button>
          {modules.map((m) => (
            <button
              key={m}
              type="button"
              className="btn-outline-conductor"
              style={{ opacity: moduleFilter === m ? 1 : 0.6, padding: 0, border: 'none', background: 'none' }}
              onClick={() => setModuleFilter(moduleFilter === m ? null : m)}
            >
              <ModuleChip module={m} />
            </button>
          ))}
        </div>
      )}

      {loading && <div className="empty">Loading…</div>}
      {error && <div className="empty">{error}</div>}

      {!loading && !error && (
        <div className="requests-list" style={{ minWidth: 380 }}>
          {visible.length === 0 && <div className="empty">No activity in the last 60 days.</div>}
          {visible.map((entry) => (
            <div className="request-row" key={entry.id}>
              <div className="request-row-main">
                <div className="request-row-title">
                  {entry.track_id ? (
                    <Link to={`/dashboard?track=${entry.track_id}`}>{entry.label}</Link>
                  ) : (
                    entry.label
                  )}
                </div>
                <div className="request-row-chips">
                  <ModuleChip module={entry.module} />
                  {entry.outcome && <span className="verdict-chip" data-verdict={entry.outcome}>{entry.outcome}</span>}
                  <span>{relativeTime(entry.timestamp)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
